const $ = window.jQuery;

$(document).ready(() => {
  let moreEventsLoaded = false;
  $('.events-list__inner .button').on('click', e => {
    e.preventDefault();

    if (!moreEventsLoaded) {
      // TODO: Logic that get's more events

      $('.events-list__inner .card').slideDown();
      $('.events-list__inner .button').text('View Full Calendar');
      moreEventsLoaded = true;
    } else {
      // Link out to calendar
    }
  });
});
